const toLowerFirst = (value: string): string =>
  value.length > 0 ? value[0].toLowerCase() + value.slice(1) : value;

export const templateNotifications = {
  created: (label = 'Template'): string => `${label} created successfully.`,
  updated: (label = 'Template'): string => `${label} updated successfully.`,
  createFailed: (label = 'Template'): string =>
    `Failed to create ${toLowerFirst(label)}.`,
  updateFailed: (label = 'Template'): string =>
    `Failed to update ${toLowerFirst(label)}.`,
  deleted: (count: number): string =>
    `${count} template${count === 1 ? '' : 's'} deleted successfully.`,
  deleteFailed: (): string => 'Failed to delete templates.',
  defaultSet: (): string => 'Template set as default.',
  defaultCleared: (): string => 'Default template cleared.',
  defaultUpdateFailed: (): string => 'Failed to update default template.',
  applied: (mode: 'add' | 'replace' = 'replace'): string =>
    mode === 'add' ? 'Template added.' : 'Template replaced.'
};
